import ShieldHalfFillExclamationmark from './ShieldHalfFillExclamationmark';

export default ShieldHalfFillExclamationmark;
